export default "__VITE_ASSET__Bo1ejkdP__"